export default {
  greeting: 'Hello, {{name}}',
  greeting_morning: 'Good morning, {{name}}',
  greeting_afternoon: 'Good afternoon, {{name}}',
  greeting_evening: 'Good evening, {{name}}',
  lease_card_title: 'Current Lease',
  property: 'Property',
  unit: 'Unit',
  period: 'Period',
  no_active_lease: 'No active lease',
  unpaid_invoices: 'Unpaid Invoices',
  pending_parcels: 'Pending Parcels',
  my_vehicles: 'My Vehicles',
  pay_now: 'Pay Now',
  view_parcels: 'View',
  view_vehicles: 'View',
  invoices_count: '{{count}} invoice(s)',
  parcels_count: '{{count}} parcel(s)',
  vehicles_count: '{{count}} vehicle(s)',
  view_lease_agreement: 'View Lease Agreement',
  lease_pdf_unavailable_title: 'Lease document unavailable',
  lease_pdf_unavailable_body: 'The stored copy of your lease could not be found. Please ask your property manager to regenerate it, or to upload a scan of the signed hard copy.',
  announcements_title: 'Announcements',
  no_announcements: 'No announcements right now',
  announcement_not_found: 'Announcement not found',
  read_more: 'Read more',
  published: 'Published',
  expires: 'Expires',
  my_rewards: 'Rewards',
  rewards_points: '{{count}} pts',
  win_pickup: 'Call a WIN',
  win_pickup_subtitle: 'Request a motorcycle taxi',
  // EP-135 Tier 1a — meeting card for shared owners + dual-role persons
  meetings_card_title: 'Meetings',
  meetings_card_subtitle_one: '1 owned unit',
  meetings_card_subtitle_other: '{{count}} owned units',
  // EP-156 T156-005 — add-friend card, shown only when liff.getFriendship()
  // reports the tenant is not yet a friend of the account's LINE OA.
  line_add_friend_title: 'Get invoices in LINE chat',
  line_add_friend_subtitle: 'Add {{account}} as a friend',
  line_add_friend_cta: 'Add friend',
}
